import Vue from 'vue'
import App from './App.vue'
// import WebConfig from '../public/config/config.js'
import router from './router'
import VueCookies from 'vue-cookies'
import store from './store'
// import axios from 'axios'
import httpRequest from '@/utils/httpRequest.js'
import httpRequestAI from '@/utils/httpRequestAI.js'
import httpsRequest from '@/utils/httpsRequest.js'
import track from '@/utils/track.js'
import ElementUI from 'element-ui'
import '@/assets/theme/index.css'
// import 'element-ui/lib/theme-chalk/index.css'
import * as echarts from 'echarts';
import 'echarts-wordcloud';

// Vue.prototype.$axios = axios;
Vue.prototype.$http = httpRequest;
Vue.prototype.$httpai = httpRequestAI;
Vue.prototype.$https = httpsRequest;
Vue.prototype.$track = track;
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;

Vue.config.silent = true;

Vue.use(VueCookies);
Vue.use(ElementUI);

// 路由导航过程中的权限认证
router.beforeEach((to, from, next) => {
	// debugger;
	let hascookie = document.cookie.indexOf('userinfo') > -1;
	if (to.meta.auth) {
		if (hascookie) {
			// if(to.name=='jianbao'){
			// 	if(document.cookie.indexOf('jianbao')>-1||document.cookie.indexOf('1921f9e1416473a1d0f15d328e837115')>-1){
			// 		next();
			// 	}
			// 	else{
			// 		alert('您未订购简报栏目,无法查看');
			// 		next(false);
			// 	}
			// }
			// else{
				next()
			// }
		} else {
			alert("您未登录，请登录后查看！");
			VueCookies.set('unlogin','1');
			VueCookies.set('fromdetail',window.location.href);
			next('/');
		}
	} else {
		next()
	}
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
